"use client";

import SliderNoArrows from "@/components/Carousel/SliderNoArrows";
import PlayerInPage from "@/components/Player/PlayerInPage";
import SideBySideText from "@/components/Text/SideBySideText";
import Testimonial from "@/components/Text/Testimonial";
import Text from "@/components/Text/Text";
import Triangles from "@/components/Triangles";
import { TestemonialBlackImg } from "@/stories/Testemonial.stories";
import { shuffle } from "@/utils";
import { SwiperSlide } from "swiper/react";
import testimonials from "../../../../public/content/testimonials.json";
import Newsletter from "@/components/Cards/Newsletter";
import { NewsletterBlue } from "@/stories/Newsletter.stories";
import FAQAccordion from "@/components/FAQAccordion";
import Title from "@/components/Text/Title";
import FAQ from "../../../../public/content/FAQ.json";
import { sendGTMEvent } from "@/components/Analytics";

export default function WarumIchSieMacheLayout() {
    return (
        <>
            <div className="bg-turquoise flex justify-center">
                <div className="container w-full md:px-20 lg:px-20 lg:py-40 pt-24 pb-10 flex-col justify-center items-center gap-6 inline-flex">
                    <Title
                        hasPreTitle={true}
                        preTitle="Worum geht’s: WARUM ICH DIE FERNBEHANDLUNG ANBIETE"
                        title="Die Fernbehandlung kann Probleme lösen, wo man sonst den Zugang unmöglich findet"
                        hasText={true}
                        hasSubTitle={false}
                        paddings="px-4 lg:px-0"
                        text="Mit der Fernbehandlung kann ich viel besser helfen, als es mit den Einzelgesprächen möglich ist."
                    />
                    <PlayerInPage
                        videoId="8f545c263ae37fed20329260859de9d8"
                        thumbnail="/images/thumbnails/macheThumbnail1.jpg"
                    />
                </div>
            </div>
            <div className="bg-turquoise">
                <Triangles backgroundColor="bg-orange" buttomToTop={false} />
            </div>
            <div className="bg-orange flex justify-center">
                <div className="container w-full px-3 flex-col justify-center items-center gap-6 inline-flex">
                    <Text
                        hasPretitle={true}
                        pretitle="EINE REISE DURCH SCHMERZ UND ERKENNTNIS"
                        title="Die Wahrheit hinter den Energiefeldern"
                        paragraphs={[
                            "Energiefelder zu sehen und alles richtig zu interpretieren, war nie ein Problem. Meine Forschungsarbeiten, um die Energiefeldmechanismen zu verstehen, war eine spannende Reise und das Abenteuer meines Lebens! Ich habe Dinge erkannt, die ich mir zuvor nicht vorstellen konnte. Das hilft mir heute, Probleme schnell zu erkennen und zu verstehen. So kann ich zuverlässig und genau arbeiten.",
                            "Meine grösste Herausforderung zu Beginn war es, damit umgehen zu lernen,  dass ich den Schmerz und die Verzweiflung, die durch Funktionsstörungen im Energiefeld entstehen, verarbeiten konnte. Zu begreifen, wie sich seelische Verletzungen langfristig bei einem Menschen auswirken, war fast nicht zu ertragen. Denn dies bedeutet nicht nur einen schlechten Tag, sondern ein verletztes Leben.",
                            "Als ich das erste Mal begriffen hatte, wie verletzte Leben aussehen, musste ich drei Tage lang zu Hause bleiben weil es mich so betroffen machte. Ich habe bei jedem Menschen, den ich getroffen habe, den Schmerz erkannt.",
                            "Natürlich leben Menschen mit ihren Schmerzen und gewöhnen sich daran, doch das ist aus meiner Sicht nicht lebenswert. Daher stand ich vor der Wahl: Sollte ich meine Wahrnehmung unterdrücken oder lernen, damit umzugehen? Heute bin ich froh, dass ich mich mit 27 Jahren dafür entschieden habe, es zu erlernen.",
                            "Ich weiss, wie man seelische Verletzungen reparieren kann. Das geht nicht immer von heute auf morgen. Ich könnte mir selbst am Morgen nicht in den Spiegel sehen, wenn ich die Fernbehandlung nicht anbieten würde. Aus meiner Erfahrung heraus ist sie die effektivste Methode, seelische Verletzungen nachhaltig zu lösen. Denn Veränderung kann nur durch starke Energiefelder erfolgen, und diese müssen intakt sein.",
                        ]}
                        pretitleSize="text-lg lg:text-xl1"
                        paddings="px-0 lg:px-74 lg:py-30 py-10 w-full md:px-20"
                        leading=""
                        leadingText="leading-7"
                        hasReadMore={true}
                        paragraphSlice={2}
                    />
                </div>
            </div>
            <div className="bg-orange">
                <Triangles backgroundColor="bg-yellow" buttomToTop={true} />
            </div>
            <div className="bg-yellow flex justify-center">
                <div className="container w-full lg:py-30  px-3 flex-col justify-center items-center gap-6 inline-flex">
                    <SideBySideText
                        elementLeft={
                            <Text
                                hasSubTitle={false}
                                hasText={false}
                                title="Warum gerade Fernbehandlung?"
                                hasPretitle={false}
                                paddings=""
                                leading="leading-8"
                            />
                        }
                        elementRight={
                            <PlayerInPage
                                videoId="b9102888985079423c46a32a2ef7abe9"
                                thumbnail="/images/thumbnails/macheThumbnail2.jpg"
                            />
                        }
                        backgroundColor="bg-yellow"
                        title="Warum gerade Fernbehandlung?"
                        imageTextColor="text-yellow"
                        imageText="ES SIND ENERGIEFELDER, DIE NICHT STANDHALTEN"
                        imageTitle="ES IST NICHT DEINE SCHULD, WENN DU NICHT GENÜGEND stark bist"
                        hasSubTitle={false}
                        hasText={false}
                        paddings="space-y-5 lg:space-y-0 py-10 px-5 lg:py-5 lg:px-0"
                    />
                </div>
            </div>
            <div className="bg-yellow">
                <Triangles backgroundColor="bg-black" buttomToTop={false} />
            </div>
            <div className="bg-black flex justify-center">
                <div className="container flex justify-center">
                    <div className=" w-full px-3 lg:px-20 ">
                        <SliderNoArrows
                            paginationColor="#FFFFFF"
                            contentEl={
                                <div className="flex justify-center items-center">
                                    {shuffle(testimonials?.testimonials)?.map(
                                        (testimonial) => {
                                            return (
                                                <SwiperSlide
                                                    key={testimonial.testimonial}
                                                >
                                                    <Testimonial
                                                        backgroundColor={
                                                            TestemonialBlackImg?.args
                                                                ?.backgroundColor
                                                        }
                                                        differentTextColor={
                                                            TestemonialBlackImg?.args
                                                                ?.differentTextColor
                                                        }
                                                        hasImage={testimonial.hasImage}
                                                        text={testimonial?.testimonial}
                                                        icon={
                                                            TestemonialBlackImg?.args
                                                                ?.icon
                                                        }
                                                        textColor={
                                                            TestemonialBlackImg?.args
                                                                ?.textColor
                                                        }
                                                        name={testimonial?.name}
                                                        hasDescription={false}
                                                        wordsInDifferentColor={[""]}
                                                        hasReadMore={true}
                                                    />
                                                </SwiperSlide>
                                            );
                                        },
                                    )}
                                </div>
                            }
                        />
                    </div>
                </div>
            </div>
            <div className="bg-black">
                <Triangles backgroundColor="bg-turquoise" buttomToTop={true} />
            </div>
            <div className="bg-turquoise flex justify-center">
                <div className="container flex justify-center">
                    <div className="  px-3 lg:px-20 ">
                        <Testimonial
                            text="Wenn ich keine Energiefelder sehen könnte und die Energiefeldmechanik nicht verstünde, würde ich nicht glauben, dass die Fernbehandlung funktioniert. "
                            wordsInDifferentColor={[
                                "Energiefelder",
                                "sehen",
                                "Energiefeldmechanik",
                                "nicht",
                                "verstünde",
                            ]}
                            differentTextColor="text-lightYellow"
                        />
                    </div>
                </div>
            </div>
            <div className="bg-turquoise">
                <Triangles backgroundColor="bg-white" buttomToTop={false} />
            </div>
            <div className="bg-white w-full px-3 lg:px-20 py-20">
                <div className="text-left md:text-center lg:text-center text-black text-xl3 lg:text-5xl font-bold  leading-7 lg:leading-14">
                    FAQ
                </div>
                <div className="text-left md:text-center lg:text-center text-black text-xl1 font-normal  leading-7 lg:leading-8.5">
                    Hier findest du Antworten darauf, warum ich die Fernbehandlung mache.{" "}
                </div>
                <div className="flex justify-center items-center my-10">
                    <FAQAccordion
                        // @ts-ignore
                        FAQItem={
                            FAQ.FAQ.find((item) => item.page === "Warum ich sie mache")
                                ?.FAQ
                        }
                        // FAQItem={FAQ}
                    />
                </div>
            </div>
            <div className="bg-white">
                <Triangles backgroundColor="bg-blue" buttomToTop={true} />
            </div>
            <div className="bg-blue flex justify-center">
                <div className="container ">
                    <Newsletter
                        backgroundColor={NewsletterBlue.args?.backgroundColor}
                        hasInput={NewsletterBlue.args?.hasInput}
                        buttonText="Jetzt buchen"
                        checkBoxText={NewsletterBlue.args?.checkBoxText}
                        description={NewsletterBlue.args?.description}
                        differentText={NewsletterBlue.args?.differentText}
                        hasCheckbox={NewsletterBlue.args?.hasCheckbox}
                        hasDescription={NewsletterBlue.args?.hasDescription}
                        hasSubText={NewsletterBlue.args?.hasSubText}
                        inputText={NewsletterBlue.args?.inputText}
                        subText={NewsletterBlue.args?.subText}
                        title={NewsletterBlue.args?.title}
                        buttonAs="a"
                        href="/de/bestellen"
                        buttonPaddings="py-4 px-8"
                        onClickButton={() => {
                            sendGTMEvent({
                                event: "cta_click",
                                section_title: "Warte nicht länger - pack es an!",
                                section_index: "7",
                                cta_text: "Jetzt buchen",
                                cta_link: `${process.env.NEXT_PUBLIC_URL}/de/bestellen`,
                            });
                        }}
                    />
                </div>
            </div>
            <div className="bg-blue">
                <Triangles backgroundColor="bg-white" buttomToTop={false} />
            </div>
        </>
    );
}
